<template>
    <div class="structure-tree">
        <StructureNode v-for="node in roots" :key="node.key" :node="node" />
    </div>
</template>

<script setup>
import { computed, provide, toRef } from 'vue';
import StructureNode from './StructureNode.vue';
import { STRUCTURE_TREE_CONTEXT } from './buildStructureTree';

const props = defineProps({
    roots: { type: Array, required: true },
    query: { type: String, default: '' },
    /** Раскрытые пользователем узлы. */
    expandedKeys: { type: Set, required: true },
    /** Предки найденных узлов: раскрыты принудительно, пока активен поиск. */
    pathKeys: { type: Set, required: true },
    busyKey: { type: String, default: null },
    agenciesByPartner: { type: Map, required: true },
    clientsByAdvertiser: { type: Map, required: true },
});

const emit = defineEmits(['toggle', 'action', 'open-users', 'edit-markup']);

provide(STRUCTURE_TREE_CONTEXT, {
    query: toRef(props, 'query'),
    busyKey: toRef(props, 'busyKey'),
    agenciesByPartner: computed(() => props.agenciesByPartner),
    clientsByAdvertiser: computed(() => props.clientsByAdvertiser),
    isForcedOpen: key => props.pathKeys.has(key),
    isExpanded: key => props.pathKeys.has(key) || props.expandedKeys.has(key),
    toggle: key => emit('toggle', key),
    runAction: (action, node) => emit('action', action, node),
    openUsers: partnerId => emit('open-users', partnerId),
    editMarkup: (target, entity, partner) => emit('edit-markup', { target, entity, partner }),
});
</script>
